function getCarouselStep(track) {
    const card = track.querySelector('.management-participation__section-2-card');
    if (!card) {
        return track.clientWidth;
    }
    const styles = window.getComputedStyle(track);
    const gap = parseFloat(styles.columnGap || styles.gap) || 0;

    return card.getBoundingClientRect().width + gap;
}

function initMpSection2Carousels() {
    document.querySelectorAll('[data-mp-s2-carousel]').forEach((root) => {
        const track = root.querySelector('[data-mp-s2-track]');
        const prev = root.querySelector('[data-mp-s2-prev]');
        const next = root.querySelector('[data-mp-s2-next]');

        if (!track || !prev || !next) {
            return;
        }

        prev.addEventListener('click', () => {
            track.scrollBy({ left: -getCarouselStep(track), behavior: 'smooth' });
        });

        next.addEventListener('click', () => {
            track.scrollBy({ left: getCarouselStep(track), behavior: 'smooth' });
        });
    });
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initMpSection2Carousels);
} else {
    initMpSection2Carousels();
}
